var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 150 213.414063 C 114.980469 213.414063 86.585938 185.019531 86.585938 150 C 86.585938 114.976563 114.980469 86.585938 150 86.585938 C 185.023438 86.585938 213.414063 114.976563 213.414063 150 C 213.414063 185.019531 185.023438 213.414063 150 213.414063 M 227.210938 170.6875 L 278.265625 150 L 227.210938 129.3125 L 261.082031 85.867188 L 206.519531 93.476563 L 214.132813 38.917969 L 170.6875 72.789063 L 150 21.734375 L 129.3125 72.789063 L 85.867188 38.917969 L 93.476563 93.476563 L 38.917969 85.867188 L 72.789063 129.3125 L 21.734375 150 L 72.789063 170.6875 L 38.917969 214.132813 L 93.476563 206.523438 L 85.867188 261.082031 L 129.3125 227.210938 L 150 278.265625 L 170.6875 227.210938 L 214.132813 261.082031 L 206.519531 206.523438 L 261.082031 214.132813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 189.859375 150 C 189.859375 172.015625 172.015625 189.859375 150 189.859375 C 127.984375 189.859375 110.140625 172.015625 110.140625 150 C 110.140625 127.984375 127.984375 110.140625 150 110.140625 C 172.015625 110.140625 189.859375 127.984375 189.859375 150 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.853291d0512cbd76e763e7f10b4275af.svg";
export { ForwardRef as ReactComponent };